export const environment = {
  production: false,
  APP_ID: '2cb1b67c-6f7f-46d8-b20d-3e7b9b7da6cc',
  API_BASE_URL: 'https://promo.qa.arv.aws.ual.com/offers/api/chasepackmoremiles',
  IMAGE_BASE_URL: 'https://promo.qa.arv.aws.ual.com/chasepackmoremiles/public/images/',
  ASSETS_BASE_URL: 'https://promo.qa.arv.aws.ual.com/assets/img/',
};
